import { render } from "./WorldSidePicker.vue?vue&type=template&id=0266212c"
import script from "./WorldSidePicker.vue?vue&type=script&lang=js"
export * from "./WorldSidePicker.vue?vue&type=script&lang=js"

import "./WorldSidePicker.vue?vue&type=style&index=0&id=0266212c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__